var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoEspeciesAmenazadas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico_especies_amenazadas",
    "data-name": "ico_especies amenazadas",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_58",
    "data-name": "Rect\\xE1ngulo 58",
    width: 100,
    height: 100,
    fill: "#f2b229"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_87",
    "data-name": "Grupo 87",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_246",
    "data-name": "Trazado 246",
    d: "M107.994,87.609q-.554-.949-1.106-1.9l-5.957-10.319Q94.366,64.02,87.8,52.647a6.276,6.276,0,0,0-1.518-1.862,5.372,5.372,0,0,0-4.36-1.038,5.583,5.583,0,0,0-3.81,2.786c-2.419,4.24-4.905,8.533-7.31,12.684C67.917,70.2,64.929,75.363,62.04,80.461c-.772,1.363-1.593,2.717-2.386,4.025a64.813,64.813,0,0,0-5.018,9.38v1.409a2.2,2.2,0,0,1,.155.651,5.346,5.346,0,0,0,5.36,4.155q21.382.014,42.763,0h2.814a5.462,5.462,0,0,0,2.324-.488,5.392,5.392,0,0,0,2.9-3.227,5.272,5.272,0,0,0-.37-4.226c-.827-1.521-1.722-3.053-2.588-4.534M81.7,65.494c.816.042,1.637.039,2.453,0,.432-.02.544.091.542.534-.02,3.72-.011,7.44-.011,11.16,0,1.792-.011,3.584.009,5.376,0,.373-.082.5-.473.483-.856-.032-1.714-.029-2.57,0-.376.013-.484-.086-.482-.474.018-2.785.01-5.57.01-8.355,0-2.727.01-5.453-.011-8.18,0-.428.085-.566.534-.543M82.91,91.218A2.337,2.337,0,1,1,85.27,88.9a2.348,2.348,0,0,1-2.36,2.315",
    transform: "translate(-32.469 -29.504)",
    fill: "#f2b229"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_247",
    "data-name": "Trazado 247",
    d: "M50,0a50,50,0,1,0,50,50A50,50,0,0,0,50,0M81.561,67.891a8.669,8.669,0,0,1-8.3,5.935H70.445q-11.128,0-22.257,0-10.256,0-20.51-.006a8.633,8.633,0,0,1-8.436-6.361l-.322-.148V63.747l.112-.285A66.37,66.37,0,0,1,24.408,53.3c.781-1.289,1.59-2.621,2.338-3.943,2.9-5.111,5.888-10.276,8.781-15.271,2.4-4.147,4.886-8.435,7.3-12.666a8.9,8.9,0,0,1,6.007-4.363,8.616,8.616,0,0,1,6.989,1.674,9.372,9.372,0,0,1,2.321,2.79q6.561,11.373,13.127,22.743L77.23,54.583q.545.944,1.1,1.884c.878,1.5,1.786,3.056,2.637,4.621a8.484,8.484,0,0,1,.6,6.8",
    fill: "#f2b229"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEspeciesAmenazadas);
export default __webpack_public_path__ + "static/media/ico_especies_amenazadas.d5641a10c8f17ec5269d3759624448fe.svg";
export { ForwardRef as ReactComponent };